var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-tab-head"},[_vm._t("default"),_c('div',{staticClass:"line",style:(_vm.lineStyle)}),_c('div',{staticClass:"control"},[_vm._t("control")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }